import { render } from "./TheFeedbackSection.vue?vue&type=template&id=408e9d54"
import script from "./TheFeedbackSection.vue?vue&type=script&lang=js"
export * from "./TheFeedbackSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__